var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodemoj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 13,
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2239 20.7559C11.8336 21.2839 12.6511 21.6764 13.5534 21.9368C14.4635 22.1996 15.4775 22.3333 16.4974 22.3333C17.5173 22.3333 18.5312 22.1996 19.4414 21.9368C20.3437 21.6764 21.1612 21.2839 21.7709 20.7559",
    stroke: "#33363F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4974,
    cy: 13.3333,
    r: 1.58333,
    fill: "#33363F",
    stroke: "#33363F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4974,
    cy: 13.3333,
    r: 1.58333,
    fill: "#33363F",
    stroke: "#33363F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodemoj);
export default __webpack_public_path__ + "static/media/goodemoj.7d821da8c33f70dd198c1501c4daf805.svg";
export { ForwardRef as ReactComponent };